import { Controller } from "@hotwired/stimulus"
import lucide from "lucide/dist/umd/lucide"

export default class extends Controller {
  connect() {
    this.createIcons()
    this.observeMutations()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  observeMutations() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type !== "childList" || mutation.addedNodes.length === 0) return

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return

          if (node.matches("i[data-lucide]")) {
            this.createIcons(node.parentElement || node)
          } else if (node.querySelector("i[data-lucide]")) {
            this.createIcons(node)
          }
        })
      })
    })

    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  createIcons(root = this.element) {
    lucide.createIcons({ root })
  }
}
